/**
 * UmlCanvasToolbarInfoRows — pure painter for the toolbar's Selected/Hover
 * info rows. Extracted 2026-07-13 from UmlCanvasToolbar.jsx to keep the class
 * file under the ~150-line rule — no own state/logic, all values come in as
 * props. onMouseDown is forwarded as-is (toolbar's own _onMouseDown, from
 * JxFormDraggableBase, so these rows remain draggable like the rest of the panel).
 *
 * @param {boolean} hideSelectedRow
 * @param {{label:string, geo:string}|null} selectedInfo
 * @param {boolean} hideHoverRow
 * @param {{label:string,x:number,y:number}|null} hoveredGeo
 * @param {object|null} hoveredConnector
 * @param {object|null} hoveredShape
 * @param {Function} getShapeById
 * @param {(e: React.MouseEvent) => void} onMouseDown
 */
export default function UmlCanvasToolbarInfoRows({
    hideSelectedRow,
    selectedInfo,
    hideHoverRow,
    hoveredGeo,
    hoveredConnector,
    hoveredShape,
    getShapeById,
    onMouseDown,
}) {
    return (
        <>
            {!hideSelectedRow && (
                <div className="uct-info-row" onMouseDown={onMouseDown}>
                    {selectedInfo ? (
                        <>
                            <span className="uct-info-label">Selected:</span>
                            <span className="uct-info-name">{selectedInfo.label}</span>
                            <span className="uct-info-geo">{selectedInfo.geo}</span>
                        </>
                    ) : (
                        <span className="uct-info-empty">No shape selected</span>
                    )}
                </div>
            )}

            {!hideHoverRow && (
                <div className="uct-info-row" onMouseDown={onMouseDown}>
                    <span className="uct-info-label">Hover:</span>
                    {hoveredGeo ? (
                        <span className="uct-info-geo">
                            {hoveredGeo.label} — x:{Math.round(hoveredGeo.x)} y:{Math.round(hoveredGeo.y)}
                        </span>
                    ) : hoveredConnector ? (
                        <span className="uct-info-geo">
                            {hoveredConnector.kind} id:{hoveredConnector.id.slice(0, 8)} —{' '}
                            {getShapeById(hoveredConnector.fromShapeId)?.caption?.text || getShapeById(hoveredConnector.fromShapeId)?.name} →{' '}
                            {getShapeById(hoveredConnector.toShapeId)?.caption?.text || getShapeById(hoveredConnector.toShapeId)?.name} (totaal{' '}
                            {hoveredConnector.points?.length || 0} waypoints)
                        </span>
                    ) : hoveredShape ? (
                        <span className="uct-info-geo">
                            {hoveredShape.caption?.text || hoveredShape.name || '(no name)'} id:{hoveredShape.id.slice(0, 8)} — x:
                            {Math.round(hoveredShape.x)} y:{Math.round(hoveredShape.y)} w:{Math.round(hoveredShape.w)} h:
                            {Math.round(hoveredShape.h)}
                        </span>
                    ) : (
                        <span className="uct-info-empty">Hover a shape or connector</span>
                    )}
                </div>
            )}
        </>
    );
}
